<template>
    <div class="timetable-text show-time">
        <div class="timetable-column" v-for="eventGroup in eventsGroupedByTime">
            {{eventGroup.start_time | format_date('H:mm')}}&nbsp;–&nbsp;
            {{eventGroup.end_time | format_date('H:mm')}}<template
                v-for="(date, index) in eventGroup.dates">, {{ date | format_date('dddd') }}</template>
            <br>
        </div>
    </div>
</template>

<script>
    import TimetableViewBase from './TimetableView-Base.vue';
    import {EventDatesMixin} from './mixins/EventDatesMixin';

    export default {
        extends: TimetableViewBase,
        mixins: [EventDatesMixin],

        created() {
            this.fixEventsData();
        },

        computed: {
            eventsGroupedByTime() {
                let eventsGroupedByTime = [];
                let eventsMap = {};
                for (let i=0; i<7; i++) {
                    let date = moment(this.date).add(i, 'days');
                    let events = this.getEventsByDate(date);

                    events.forEach((event) => {
                        let eventKey = event._start_time.format('HH:mm') + '-' + event._end_time.format('HH:mm');
                        if (!eventsMap[eventKey]) {
                            eventsMap[eventKey] = {
                                start_time: event._start_time,
                                end_time: event._end_time,
                                // events: [],
                                dates: []
                            }
                        }

                        // eventsMap[eventKey].events.push(event);
                        eventsMap[eventKey].dates.push(date);
                    });
                }

                eventsGroupedByTime = Object.values(eventsMap);

                return eventsGroupedByTime.map((eventGroup) => {
                    eventGroup.dates.sort((d1, d2) => {
                        return d1.isoWeekday() - d2.isoWeekday();
                    });
                    return eventGroup;
                }).sort((g1, g2) => {
                    return g1.dates[0].isoWeekday() - g2.dates[0].isoWeekday()
                });
            }
        },
    }
</script>
<style>
</style>